<template>
    <div id="app" >
      <top-menu/>
      <br/>
      <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
      <div class="app-content">
        <router-view/>
      </div>
    </div>
</template>
 
<script>
import Menu from './components/Menu'
import { mapState, mapActions } from 'vuex'

export default {
  name: "app",
  components: {
    'top-menu': Menu
  },
  computed: {
      ...mapState({
          alert: state => state.alert
      })
  },
  methods: {
      ...mapActions({
          clearAlert: 'alert/clear' 
      })
  },
  watch: {
    /* eslint-disable no-unused-vars */
      $route (to, from){
    /* eslint-enable no-unused-vars */
          // clear alert on location change
          this.clearAlert();
      }
  },

  created() {
    /* eslint-disable no-console */
    console.log('App created. ')
    /* eslint-enable no-console */
  },
  mounted() {
    /* eslint-disable no-console */
    console.log('App mounted.')
    this.$store.dispatch('games/retrieveGames');
    /* eslint-enable no-console */
  }
};
</script>
 
<style>
.site-info {
  color: blue;
  margin-bottom: 20px;
}
 
.btn-primary {
  margin-right: 5px;
}
 
.container-fluid {
  text-align: center;
}

.app-content {
  display: flex;
  justify-content: center;
  height: 100%;
}
</style>